import { Environment, ResponseData } from '@t-llevo/util';
import { LicenseCategory } from '../../common/models/LicenseCategory';
import { LicenseCategoryResponse } from '../models/responses/LicenseCategoryResponse';
import { BaseCrudService } from '@t-llevo/common-ui';
import { BehaviorSubject, map, of, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { LicenseCategoryMapper } from '../mappers/LicenseCategoryMapper';
import { apiLicenseCategoryRoutes as apiRoutes } from '../routes/api-license-category-routes';
import { LicenseCategoryRequest } from '../models/requests/LicenseCategoryRequest';

@Injectable()
export class LicenseCategoryService extends BaseCrudService<
  LicenseCategory,
  ResponseData<LicenseCategoryResponse>
> {
  private categoriesSub = new BehaviorSubject<LicenseCategory[] | null>(null);
  categories$ = this.categoriesSub.asObservable();

  constructor(@Inject(Environment) env: Environment, http: HttpClient) {
    super(env, http);
  }

  override transform(data: ResponseData<LicenseCategoryResponse>) {
    return {
      ...data,
      results: data.results.map((cat) => LicenseCategoryMapper(cat)),
    };
  }

  createCategory(params: LicenseCategoryRequest) {
    return this.http.post<LicenseCategoryRequest>(
      this.env.apiUrl + apiRoutes.routeLicenseCategories,
      params,
    );
  }

  updateCategory(params: LicenseCategoryRequest, id: string) {
    return this.http.patch<LicenseCategoryRequest>(
      this.env.apiUrl + apiRoutes.routeLicenseCategories + `${id}`,
      params,
    );
  }

  deleteCategory(id: string) {
    return this.http.delete(
      this.env.apiUrl + apiRoutes.routeLicenseCategories + `${id}`,
    );
  }

  getCategories() {
    if (this.categoriesSub.value) {
      return of(this.categoriesSub.value);
    } else {
      const url = this.env.apiUrl + apiRoutes.routeLicenseCategories;
      return this.http.get<LicenseCategoryResponse[]>(url).pipe(
        map((data) => {
          return data.map((cat) => LicenseCategoryMapper(cat));
        }),
        tap((data) => this.categoriesSub.next(data)),
      );
    }
  }
}
